export const getTableInterval = (data) => {
	switch (data) {
		case '1d':
			return '24H';
		case '7d':
			return '1W';
		case '30d':
			return '1M';
		case '365d':
			return '1Y';
		case 'ytd':
			return 'YTD';
	}
};
